import { createAction, props } from '@ngrx/store';

import type { FileItem } from '@app/types/file-item.type';

export const ADD_ITEM = '[Breadcrumb] Add item';
export const ADD_PARENT = '[Breadcrumb] Add parent';

export const LOAD_BREADCRUMB = '[Breadcrumb] Load breadcrumb';
export const LOAD_BREADCRUMB_FAIL = '[Breadcrumb] Load breadcrumb fail';

export const RESET_BREADCRUMB_STATE = '[Breadcrumb] Reset state';

export const addItem: any = createAction(ADD_ITEM, props<{ folder: FileItem }>());

export const addParent: any = createAction(
  ADD_PARENT,
  props<{ folder: FileItem; last?: boolean }>(),
);

export const loadBreadcrumb: any = createAction(LOAD_BREADCRUMB, props<{ id?: string }>());

export const loadBreadcrumbFail: any = createAction(
  LOAD_BREADCRUMB_FAIL,
  props<{ error: string }>(),
);

export const resetBreadcrumbState: any = createAction(RESET_BREADCRUMB_STATE);
